import { render } from "./Switch.vue?vue&type=template&id=32815e18"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"
script.render = render

export default script